import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import AddItemsFormField from '../../common/components/AddItemsFormField';
import advisorForm from '../fbSettings/advisorForm';
import settingsSelectors from '../settingsSelector';
import { loadAdvisors, updateAdvisors } from '../settingsReducer';
import { AppDispatch } from '../../store';
import { Setting } from '../../common/types/settings';

function AdvisorsSettings() {
  const dispatch: AppDispatch = useDispatch();
  const advisors = useSelector(settingsSelectors.getAdvisors);

  React.useEffect(() => {
    dispatch(loadAdvisors());
  }, []);

  return (
    <AddItemsFormField
      key='advisors'
      expanded
      items={advisors}
      form={advisorForm}
      renderItemEntry={(item: Setting) => (
        <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start'>
          <Typography>{item.value}</Typography>
        </Stack>
      )}
      updateItem={async (updatedItem) => {
        const isNewAdvisor = advisors.find((advisor) => advisor.id === updatedItem.id) === undefined;

        const newAdvisors = isNewAdvisor
          ? advisors.concat([updatedItem])
          : advisors.map((advisor) => {
              if (advisor.id === updatedItem.id) {
                return updatedItem;
              }
              return advisor;
            });
        await dispatch(updateAdvisors(newAdvisors));
        await dispatch(loadAdvisors());
      }}
      deleteItem={async (updatedItem) => {
        const newAdvisor = advisors.filter((advisor) => advisor.id !== updatedItem.id);
        await dispatch(updateAdvisors(newAdvisor));
        await dispatch(loadAdvisors());
      }}
    />
  );
}

export default AdvisorsSettings;
